import React from 'react'
import { TextField } from 'admin-on-rest'

export const StudentsCountField = ({
  record = {},
  willDisplayRemainingSpots = false,
}) => {
  return willDisplayRemainingSpots ? (
    <span>
      {record.availableSpots - Object.keys(record.students || {}).length}
    </span>
  ) : (
    <span>{`${Object.keys(record.students || {}).length} / ${
      record.availableSpots
    }`}</span>
  )
}



// WEBPACK FOOTER //
// ./src/components/StudentsCountField.js